import React from 'react';

import escapeRegex from './escape-regex';

const highlightMatches = (line: string, queryRegExp: RegExp): React.ReactNode[] => {
    const parts: React.ReactNode[] = [];
    queryRegExp.lastIndex = 0;
    let lastIndex = 0;
    let key = 0;
    while (true) {
        const match = queryRegExp.exec(line);
        if (!match) {
            parts.push(line.substring(lastIndex));
            break;
        }
        parts.push(line.substring(lastIndex, match.index));
        parts.push(<strong key={key++}>{match[0]}</strong>);
        lastIndex = queryRegExp.lastIndex;
    }
    return parts.filter((part) => part !== '');
};

/*
 * Returns React nodes (never an HTML string) so review/response text is always escaped by React.
 *  - Splits content into one paragraph (or span) per non-empty line.
 *  - Adds highlighting around search terms.
 */
const makeRenderContent = (query: string | null | undefined) => {
    const queryWords = query ? query.split(/\s+/).filter(Boolean) : [];
    const queryRegExp = queryWords.length
        ? RegExp(queryWords.map(escapeRegex).join('|'), 'gi')
        : null;

    const renderContent = (content: string, shouldUseSeparateParagraphs = true): React.ReactNode => {
        const Tag = shouldUseSeparateParagraphs ? 'p' : 'span';
        return content
            .split(/\n+/)
            .filter((line) => line !== '')
            .map((line, index) => (
                <Tag key={index}>{queryRegExp ? highlightMatches(line, queryRegExp) : line}</Tag>
            ));
    };
    return renderContent;
};

export default makeRenderContent;
